import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/suppliers/$id')({
  component: SupplierDetailsPage
})

function SupplierDetailsPage() {
  return <div>Supplier details</div>
}
